import WidgetTypeEnum from '~/enums/widgets/WidgetTypeEnum'

import TitleAndArrows from '~/components/Widgets/TitleAndArrows.vue'
import BannerSlider from '~/components/Widgets/BannerSlider/BannerSlider.vue'
import StoreSlider from '~/components/Widgets/StoreSlider/StoreSlider.vue'
import FullBanner from '~/components/Widgets/StoreBanners/FullBanner.vue'
import DoubleBannerEqual from '~/components/Widgets/StoreBanners/DoubleBannerEqual.vue'
import DoubleBannerThirds from '~/components/Widgets/StoreBanners/DoubleBannerThirds.vue'
import InfoCardGrid from '~/components/Widgets/InfoCard/InfoCardGrid.vue'
import BrandsSlider from '~/components/Widgets/BrandsSlider.vue'
import StoreTabs from '~/components/Widgets/StoreTabs/StoreTabs.vue'
import TripleBannerEqual from '~/components/Widgets/StoreBanners/TripleBannerEqual.vue'
import Divider from '~/components/Widgets/Divider.vue'
import CategoryProductSlider from '~/components/Widgets/CategoryProduct/CategoryProductSlider.vue'
import ProductSlider from '~/components/Widgets/ProductSlider.vue'
import ProductBanner from '~/components/Widgets/ProductBanner.vue'
import InfoCardSlider from '~/components/Widgets/InfoCard/InfoCardSlider.vue'
import Faq from '~/components/Widgets/Faq.vue'
import OffersSlider from '~/components/Widgets/OffersSlider.vue'
import ManualCategoryProductSlider from '~/components/Widgets/CategoryProduct/ManualCategoryProductSlider.vue'
import QuoteFormBox from '~/components/Widgets/QuoteFormBox.vue'
import FeaturedPosts from '~/components/Widgets/FeaturedPosts.vue'
import Separator from '~/components/Widgets/Separator.vue'
import Alert from '~/components/Widgets/AlertWidget/AlertWidget.vue'
import MegamenuBanners from '~/components/Widgets/MegamenuBanners.vue'
import BrandsGrid from '~/components/Widgets/BrandsGrid.vue'
import PromoVideo from '~/components/Widgets/PromoVideo.vue'

import type { DefineComponent } from 'vue'

const map: Record<WidgetTypeEnum, DefineComponent<any, any, any, any>> = {
  [WidgetTypeEnum.TitleAndArrows]: TitleAndArrows,
  [WidgetTypeEnum.BannerSlider]: BannerSlider,
  [WidgetTypeEnum.StoreSlider]: StoreSlider,
  [WidgetTypeEnum.FullBanner]: FullBanner,
  [WidgetTypeEnum.DoubleBannerEqual]: DoubleBannerEqual,
  [WidgetTypeEnum.DoubleBannerThirds]: DoubleBannerThirds,
  [WidgetTypeEnum.InfoCardGrid]: InfoCardGrid,
  [WidgetTypeEnum.BrandsSlider]: BrandsSlider,
  [WidgetTypeEnum.StoreTabs]: StoreTabs,
  [WidgetTypeEnum.TripleBannerEqual]: TripleBannerEqual,
  [WidgetTypeEnum.Divider]: Divider,
  [WidgetTypeEnum.CategoryProductSlider]: CategoryProductSlider,
  [WidgetTypeEnum.ProductSlider]: ProductSlider,
  [WidgetTypeEnum.ProductBanner]: ProductBanner,
  [WidgetTypeEnum.InfoCardSlider]: InfoCardSlider,
  [WidgetTypeEnum.Faq]: Faq,
  [WidgetTypeEnum.OffersSlider]: OffersSlider,
  [WidgetTypeEnum.ManualCategoryProductSlider]: ManualCategoryProductSlider,
  [WidgetTypeEnum.QuoteFormBox]: QuoteFormBox,
  [WidgetTypeEnum.FeaturedPosts]: FeaturedPosts,
  [WidgetTypeEnum.Separator]: Separator,
  [WidgetTypeEnum.Alert]: Alert,
  [WidgetTypeEnum.MegamenuBanners]: MegamenuBanners,
  [WidgetTypeEnum.BrandsGrid]: BrandsGrid,
  [WidgetTypeEnum.PromoVideo]: PromoVideo,
}

function findComponentByType(type: WidgetTypeEnum) {
  return Object.prototype.hasOwnProperty.call(map, type) ? map[type] : null
}

export { map, findComponentByType }
